module.exports = __webpack_public_path__ + "static/media/pe.5d005ee9.svg";